export class DateOnly {
    static parse(input: string): DateOnly {
        const [y, m, d] = input.split("-").map(Number);
        return new DateOnly(y, m, d);
    }

    static fromDate(d: Date): DateOnly { 
        return new DateOnly(d.getFullYear(), d.getMonth()+1, d.getDate()); 
    }  

    constructor(public year: number, public month: number, public day: number) { }

    format(): string {
        return this.day.toString().padStart(2, "0") + "." + this.month.toString().padStart(2, "0") + "." + this.year.toString().padStart(4, "0");
    }
    
    toString(): string {
        return this.year.toString().padStart(4, "0") + "-" + this.month.toString().padStart(2, "0") + "-" + this.day.toString().padStart(2, "0");
    }

    toDate(): Date {
        return new Date(this.toString() + "T00:00:00");
    }

    toJSON(): string {
        return this.toString();
    }
}
